module.exports = __webpack_public_path__ + "img/PowerSpeedRefCurve.3f8359dd.png";